import { render, staticRenderFns } from "./fireFightingDocumentTab.vue?vue&type=template&id=1fb7ebae"
import script from "./fireFightingDocumentTab.vue?vue&type=script&lang=js"
export * from "./fireFightingDocumentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb7ebae')) {
      api.createRecord('1fb7ebae', component.options)
    } else {
      api.reload('1fb7ebae', component.options)
    }
    module.hot.accept("./fireFightingDocumentTab.vue?vue&type=template&id=1fb7ebae", function () {
      api.rerender('1fb7ebae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/sdf/fireFightingDocumentTab.vue"
export default component.exports